<template>
  <div class="d1">
    <van-panel>
      <van-card
        :title="item.itemName"
        :desc="item.fullCategoryName"
        :thumb="item.indexImage.imageUrl"
        @click="goCommoditydetails(item)"
      >
        <template #tags>
          <div class="sp1">￥{{ item.price }}</div>
          <div class="sp2" @click.stop="goTimeView('/pdUpdateDetail', item.id)">
            上次更新时间：{{ item.gmtModified }}
            <van-icon class="sp2-1" name="arrow" />
            <!-- <img
              v-if="item.top == 2"
              class="star-icon"
              src="../../../assets/image/check_star.png"
              @click.stop="handleTop(1, item)"
            />
            <img
              v-if="item.top == 1"
              class="star-icon"
              src="../../../assets/image/uncheck_star.png"
              @click.stop="handleTop(2, item)"
            /> -->
          </div>
          <div class="virtual-tips" v-if="item.isVirtual == 'y'">虚拟商品</div>
        </template>
      </van-card>
      <template #header>
        <div class="van-cell van-panel__header">
          <!-- <van-icon class="van-icon van-icon-shop-o van-cell__left-icon" name="shop-o" /> -->
          <img class="te3" src="../../../assets/image/brand.png" />
          <span class="te">{{ item.branchName }}</span>
          <div class="te2">{{ item.leftTopTip }}</div>
        </div>
      </template>
      <template #footer>
        <van-button
          @click="downFun(item, 'n')"
          v-if="item.leftTopTip == '出售中' || item.leftTopTip == '已售罄'"
          size="small"
          class="b1"
          >下架</van-button
        >
        <van-button
          v-if="
            item.supplierChannel != 1 &&
            (item.leftTopTip == '出售中' ||
              item.leftTopTip == '已下架' ||
              item.leftTopTip == '已售罄')
          "
          size="small"
          class="b2"
          @click="goKuCunView(item.id)"
          >库存管理</van-button
        >
        <van-button
          v-if="item.leftTopTip == '已下架'"
          @click="upFun(item, 'y')"
          size="small"
          class="b1"
          >上架</van-button
        >
        <van-button
          v-if="
            showButtonVisible &&
            item.leftTopTip != '待审核' &&
            item.leftTopTip != '已售罄'
          "
          size="small"
          class="b2"
          @click="goEditeFun(item)"
          >编辑</van-button
        >
        <van-button
          v-if="
            showButtonVisible &&
            item.supplierChannel != 1 &&
            (item.leftTopTip == '草稿' || item.leftTopTip == '拒绝')
          "
          size="small"
          class="b1"
          @click="deleteFun(item.id)"
          >删除</van-button
        >
        <van-button
          @click="cancelFun(item)"
          v-if="showButtonVisible && item.leftTopTip == '待审核'"
          size="small"
          class="b2"
          >撤回审核</van-button
        >
      </template>
    </van-panel>
  </div>
</template>
<script>
import utils from "@/utils/common";
import http from "@/utils/axios";
import { Dialog } from "vant";
export default {
  name: "beeAdministrate-list-item",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    isBeeGoodsList: {
      type: Boolean,
      default: false,
      required: false,
    },
    showButtonVisible: {
      type: Boolean,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leftTopTipFormat: {
        出售中: "1",
        已下架: "2",
        已售罄: "2",
        待审核: "3",
        被拒绝: "4",
        草稿: "4",
      },
    };
  },
  methods: {
    handleTop(type, row) {
      console.log(type);
      // 置顶时需要判断该店铺是否满10个置顶商品
      if (type == 2) {
        http({
          url: "order/item/quick/selectBranchGoodsNum/" + row.branchNo,
          method: "get",
        })
          .then((rps) => {
            if (rps.data < 10) {
              http({
                url: "order/item/quick/updateGoodsTop/" + row.id,
                parmes: {
                  goodsId: row.id,
                  top: type,
                },
                method: "post",
              })
                .then((rps) => {
                  if (rps.code == 200) {
                    if (type == 2) {
                      this.$toast("商品置顶成功，将在店铺主页优先展示");
                    } else {
                      this.$toast("商品已取消置顶");
                    }
                    this.$emit("callbackInit");
                  }
                })
                .catch((rps) => {});
            } else {
              Dialog.confirm({
                title: "提示",
                message:
                  "店铺已设置超过10个置顶商品，如确认将会替换之前置顶商品，确认置顶吗？",
                confirmButtonColor: "#007AFF",
              })
                .then(() => {
                  // on confirm
                  http({
                    url: "order/item/quick/updateGoodsTop/" + row.id,
                    parmes: {
                      goodsId: row.id,
                      top: type,
                    },
                    method: "post",
                  })
                    .then((rps) => {
                      if (rps.code == 200) {
                        if (type == 2) {
                          this.$toast("商品置顶成功，将在店铺主页优先展示");
                        } else {
                          this.$toast("商品已取消置顶");
                        }
                        this.$emit("callbackInit");
                      }
                    })
                    .catch((rps) => {});
                })
                .catch(() => {
                  // on cancel
                });
            }
          })
          .catch((rps) => {});
      } else if (type == 1) {
        http({
          url: "order/item/quick/updateGoodsTop/" + row.id,
          parmes: {
            goodsId: row.id,
            top: type,
          },
          method: "post",
        })
          .then((rps) => {
            if (rps.code == 200) {
              if (type == 2) {
                this.$toast("商品置顶成功，将在店铺主页优先展示");
              } else {
                this.$toast("商品已取消置顶");
              }
              this.$emit("callbackInit");
            }
          })
          .catch((rps) => {});
      }
    },
    upFun(item, upShelf) {
      const doUpShelf = () => {
        http({
          url: "order/item/quick/bees/upShelf",
          method: "put",
          parmes: {
            id: item.id,
            isHot: "",
            upShelf: upShelf,
          },
        })
          .then((rps) => {
            this.$emit("callbackInit");
          })
          .catch((rps) => {});
      };
      //自动上下架类型:1审核通过后即上架 2审核通过后下架 3自定义上下架时间
      if (upShelf === "y" && item.autoLoadType === 3 && item.autoLoadTime) {
        // 判断自动上架时间 是否失效
        //ios上 2020-10-01 10:10:10 这样格式会不生效，要替换成 2020/10/01 10:10:10 格式
        if (
          new Date(item.autoLoadTime.replace(/\-/g, "/")).getTime() >
          new Date().getTime()
        ) {
          this.$dialog
            .confirm({
              title: "提示",
              message:
                "该商品已设置自动上下架时间，如手动调整上下架状态，将会清除已设置的自动上下架时间",
            })
            .then(() => {
              doUpShelf();
            });
          return;
        }
      }
      doUpShelf();
    },
    downFun(item, upShelf) {
      this.$dialog
        .confirm({
          title: "",
          message: "确定要下架该商品吗?",
        })
        .then(() => {
          this.upFun(item, upShelf);
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteFun(id) {
      this.$dialog
        .confirm({
          title: "",
          message: "确定删除该商品吗?",
        })
        .then(() => {
          this.doDelete(id);
        })
        .catch(() => {
          // on cancel
        });
    },
    doDelete(id) {
      http({
        url: "item/item/quick/delete?id=" + id,
        method: "delete",
        parmes: {},
      })
        .then((rps) => {
          this.$emit("callbackInit");
        })
        .catch((rps) => {});
    },
    cancelFun(row) {
      this.$dialog
        .confirm({
          title: "",
          message: "确定撤销审核该商品吗?",
        })
        .then(() => {
          this.doCancel(row);
        })
        .catch(() => {
          // on cancel
        });
    },
    doCancel(row) {
      let type = this.leftTopTipFormat[row.leftTopTip];

      http({
        url: "order/bee/goods/goodsStateOperate",
        method: "post",
        parmes: {
          goodsId: row.id,
          type: type,
        },
      })
        .then((rps) => {
          this.$emit("callbackInit");
        })
        .catch((rps) => {});
    },
    goCommoditydetails(row) {
      if (this.isEdit) return; // 在offShelvesProducts里会用到此参数
      utils.jumpToNewPage({
        url:
          location.origin +
          "/h5user/beeCommoditydetails?id=" +
          row.id +
          "&from=beeGoodsList&beeUpShelf=" +
          row.upShelf,
        noTitle: "0",
      });
    },
    goTimeView(url, id) {
      if (this.isEdit) return;
      utils.jumpToNewPage({
        url: location.origin + "/h5user" + url + "?goodsId=" + id,
        noTitle: "0",
      });
    },
    goKuCunView(id) {
      utils.jumpToNewPage({
        url: location.origin + "/h5user/manageStock?goodsId=" + id,
        noTitle: "1",
      });
    },
    goEditeFun(row) {
      if (row.editStatus == "1") {
        Dialog.alert({
          message: "该商品不支持手机端编辑，请至管理后台编辑",
        }).then(() => {
          // on close
        });
        return;
      }
      // else
      // if (
      //   row.editStatus == "1" ||
      //   (row.isVirtual == "y" &&
      //     (row.checkStatus == "FINISH" ||
      //       row.checkStatus == "REJECT" ||
      //       row.checkStatus == "NO_COMMIT"))
      // ) {
      //   Dialog.alert({
      //     message: "该商品不支持手机端编辑，请至管理后台编辑",
      //   }).then(() => {
      //     // on close
      //   });
      //   return;
      // }
      utils.goPageByName({
        id: "beeGoods",
        name: "蜜蜂商品管理新增/修改",
        params: { goodsId: row.id },
      });
    },
  },
  created() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.d1 {
  margin-top: 20px;
}
.te {
  width: 50%;
}
.te2 {
  font-size: 26px;
  color: #f8a651;
  text-align: right;
  width: 50%;
}
.te3 {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.van-card {
  background-color: #fff;
}
.van-card__title {
  color: #333333;
  font-size: 26px;
}
.van-panel__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
}
.van-card__desc {
  font-size: 20px;
  height: 28px;
  line-height: 28px;
  color: rgba(153, 153, 153, 1);
  margin-top: 20px;
}
/deep/.van-card__thumb img {
  border-radius: 0;
}
.b1 {
  width: 166px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  border-radius: 32px;
  border: 2px solid rgba(153, 153, 153, 1);
  margin-right: 5px;
}
.b2 {
  margin-left: 10px;
  width: 160px;
  height: 60px;
  background: rgba(248, 213, 65, 1);
  border-color: rgba(248, 213, 65, 1);
  border-radius: 32px;
  margin-right: 5px;
}
.sp1 {
  font-size: 24px;
  color: rgba(237, 57, 57, 1);
  height: 37px;
  line-height: 37px;
  margin-top: 19px;
}
.sp2 {
  position: relative;
  font-size: 20px;
  color: rgba(204, 204, 204, 1);
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  .sp2-1 {
    width: 32px;
    height: 28px;
    line-height: 28px;
  }
}
.virtual-tips {
  width: 140px;
  height: 36px;
  line-height: 36px;
  background: #fd9090;
  border-radius: 10px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: absolute;
  left: -176px;
  bottom: -50px;
}
.van-panel__content {
  position: relative;
}
.star-icon {
  position: absolute;
  width: 70px;
  height: 70px;
  right: 0;
  top: -22px;
}
</style>
